import { CreatedBy, UpdatedBy } from "@components/backoffice/ChangedBy";
import { MetadataTable } from "@components/backoffice/MetadataTable";
import { PropTypes } from "prop-types";
import React from "react";
import { Grid } from "semantic-ui-react";
import { DateTime } from "luxon";
import { toShortDateTime } from "@api/date";

export const OrderInformation = ({ order }) => {
  const { metadata } = order;
  const leftTable = [
    { name: "Literature Title", value: metadata.document?.title || "-" },
    { name: "Delivered on", value: metadata.received_date || "-" },
    { name: "Acquisition type", value: metadata.purchase_type || "-" },
    { name: "Remarks", value: metadata.remarks || "-" },
    { name: "Notes", value: metadata.notes || "-" },
    { name: "Cost per book", value: `₱${metadata.cost}` },
  ];

  const rightTable = [
    { name: "Status", value: metadata.status },
    ...(metadata.status === "CANCELLED"
      ? [{ name: "Cancel reason", value: metadata.cancel_reason }]
      : []),
    { name: "Created by", value: <CreatedBy metadata={metadata} /> },
    {
      name: "Created",
      value: toShortDateTime(DateTime.fromISO(order.created)),
    },
    { name: "Updated by", value: <UpdatedBy metadata={metadata} /> },
    {
      name: "Last updated",
      value: toShortDateTime(DateTime.fromISO(order.updated)),
    },
    { name: "Total Cost", value: `₱${metadata.total_cost}` },
    ...(metadata.legacy_id
      ? [{ name: "Legacy ID", value: metadata.legacy_id }]
      : []),
  ];

  return (
    <Grid columns={2} id="order-info">
      <Grid.Row>
        <Grid.Column>
          <MetadataTable labelWidth={5} rows={leftTable} />
        </Grid.Column>
        <Grid.Column>
          <MetadataTable labelWidth={5} rows={rightTable} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

OrderInformation.propTypes = {
  order: PropTypes.object.isRequired,
};
